import React from 'react'
import { useEffect } from 'react'
import "./main.css"
import "./com.css"



function Evenementiel() {

    useEffect(() => {
        window.scroll(0,0)
    }, [])

    return (
        <div className="contenu ">
            <div className="sidePhoto evenementiel"></div>
            <div id="textCom">
                <h2>Evénementiel sportif</h2>
                <div className="parag">
                    <p>Nous sommes <strong>à vos côtés</strong> dans <strong>toutes les phases du projet</strong>, pour concevoir et réaliser les événements dont vous rêvez.  Notre mission principale, réussir à <strong>transcrire vos envies</strong> et <strong>vos besoins</strong> en événement, selon un <strong>cahier des charges précis</strong> tout en <strong>respectant le budget prévisionnel</strong> établi. </p>
                </div>

                <div className="parag">
                    <h3>Nous assurons à la carte selon vos besoins, la conception, le management et la réalisation de votre projet à travers ses différentes étapes :</h3>
                </div>

                <ul className="ulEspace">
                    <li>Demandes d’<strong>autorisations</strong> auprès des <strong>municipalités</strong> et des <strong>fédérations sportives</strong>.</li>
                    <li>Montage et suivi des <strong>dossiers de subventions</strong> auprès des différentes institutions.</li>
                    <li><strong>Relation</strong> avec les <strong>prestataires</strong>, les <strong>fournisseurs</strong> et les différents intervenants.</li>
                    <li><strong>Pilotage logistique</strong>, élaboration et suivi du <strong>rétroplanning</strong>.</li>
                    <li>Nous définissons le <strong>budget</strong> ensemble, assurons le <strong>suivi</strong> et le <strong>respect</strong> de celui-ci.</li>
                    <li><strong>Création</strong> et <strong>diffusion</strong> des supports de <strong>communication</strong> destinés à la <strong>promotion de l’événement</strong> pour donner de la <strong>visibilité</strong> à votre événement et en faire un <strong>succès</strong>.</li>
                    <li>Nous sommes à vos côtés pour <strong>renforcer</strong> les <strong>relations</strong> avec vos <strong>partenaires</strong> actuels ou vous mettre en relation avec des <strong>nouveaux</strong>, prêts à s’investir dans vos projets.</li>
                    <li><strong>Relation médias</strong> : création d’un <strong>dossier de presse</strong>, <strong>conférence de presse</strong>, <strong>communiqués de presse</strong>, <strong>accueil des médias</strong> durant l’événement.</li>
                    <li><strong>Suivi</strong> du déroulement de l’événement <strong>jusqu’au débriefing</strong>.</li>
                </ul>
                <div className='rajout_vide'></div>
            </div>
        </div>
    )
}

export default Evenementiel
